import React, { type ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: ReactNode;
  className?: string;
  delay?: number;
};
export function Reveal({
  children,
  className = '',
  delay = 0.08
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  return <motion.div className={className} initial={reduceMotion ? false : {
    y: 10
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.4,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-306" data-mp="hreuxkpr23hk">
      {children}
    </motion.div>;
}